import { useMyPanel } from "./useMyPanel";
import { isBaleLink as checkBaleLink } from "utils/payment";
import { AdType } from "core/orderAd/orderAd.slice";
import { useConfigs } from "./useConfigs";
import { AdSpot, targetType } from "core/orderAd/orderAd.entity";

export const useCampaignPrice = (campaignDetail: {
  description: string;
  adSpot: AdSpot;
  adType?: AdType;
  target_type?: targetType;
}) => {
  const configs = useConfigs();
  const panel = useMyPanel();
  const isBaleLink = checkBaleLink(campaignDetail.description);

  if (campaignDetail.adSpot === AdSpot.AdSpotSponsoredMessage) {
    return isBaleLink
      ? configs.sponsored_message_view_price
      : configs.sponsored_message_external_view_price;
  }

  const externalCoef = isBaleLink ? 1 : configs.external_coef;
  const basePrice =
    campaignDetail.adType === AdType.view
      ? configs.campaign_view_price
      : configs.campaign_click_price;
  const campaignCoef =
    campaignDetail.adType === AdType.view
      ? panel.campaign_view_coef
      : panel.campaign_click_coef;

  const price = basePrice * externalCoef * (campaignCoef / 1000);
  return price + (campaignDetail.target_type ? price * 0.2 : 0);
};
